
import { useState } from 'react';
import { Link } from 'react-router-dom';

const LearningDashboard = () => {
  const [currentStreak, setCurrentStreak] = useState(7);
  const [totalPoints, setTotalPoints] = useState(1250);
  const [completedLessons, setCompletedLessons] = useState(23);

  return (
    <section className="bg-gradient-to-br from-blue-600 to-purple-700 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Welcome Back! Ready to Learn?
            </h1>
            <p className="text-xl text-blue-100">
              Continue your English journey with interactive exercises and track your amazing progress!
            </p>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-2">{currentStreak} Days</h3>
              <p className="text-blue-100">Current Streak</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-star-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-2">{totalPoints.toLocaleString()}</h3>
              <p className="text-blue-100">Total Points</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-checkbox-circle-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-2">{completedLessons}</h3>
              <p className="text-blue-100">Lessons Completed</p>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8">
              <h3 className="text-2xl font-bold mb-4">Continue Learning</h3>
              <p className="text-blue-100 mb-6">
                Pick up where you left off with your current lesson on "Present Perfect Tense"
              </p>
              <button className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-play-circle-line mr-2"></i>
                Continue Lesson
              </button>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8">
              <h3 className="text-2xl font-bold mb-4">Need Extra Help?</h3>
              <p className="text-blue-100 mb-6">
                Book a private video lesson with me for personalized guidance and practice
              </p>
              <Link
                to="/lessons"
                className="bg-purple-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                <i className="ri-video-chat-line mr-2"></i>
                Book Private Lesson
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LearningDashboard;
